import React, { useState } from "react";
import { Box } from "@mui/material";
import SubscriptionCard from "./SubscriptionCard";
import { usePremiumStatus } from "../../context/PremiumStatusContext";
import { PlanType, subscriptionPlans } from "./SubscriptionsPlansData";
import SegmentedControl from "../SegmentedControl";
import Switcher from "../Switcher";

const SubscriptionPlans: React.FC = () => {
  const [selectedRole, setSelectedRole] = useState("contractor");
  const [isMonthly, setIsMonthly] = useState(true);
  const { isSubscribedStripe, currentRoleStripe, subscriptionTypeStripe } =
    usePremiumStatus();

  const rolePlans =
    subscriptionPlans[selectedRole as keyof typeof subscriptionPlans];
  const planType = isMonthly ? "monthly" : "yearly";

  if (!rolePlans) return <div>Role not found</div>;

  const renderPlans = () => {
    return Object.keys(rolePlans)
      .filter((planKey) => {
        // Skip description key and filter based on subscription status
        if (planKey === "description") return false;
        if (isSubscribedStripe) {
          return (
            selectedRole === currentRoleStripe &&
            planKey.toLowerCase() === subscriptionTypeStripe.toLowerCase()
          );
        }
        return true;
      })
      .map((planKey) => {
        const category = rolePlans[planKey as keyof typeof rolePlans] as
          | PlanType
          | undefined;
        const plan = category?.[planType];
        const description = rolePlans.description;

        if (!plan) return null;

        return (
          <SubscriptionCard
            key={planKey}
            planKey={planKey}
            planType={planType}
            productId={plan.productId}
            features={plan.features}
            description={description}
            isMonthly={isMonthly}
          />
        );
      });
  };

  return (
    <main className="gap-8 py-6 ">
      <div className="flex-col items-center gap-8 py-6 border-2 rounded-xl p-8 w-full bg-white shadow-lg flex justify-between min-w-[30vw]">
        <div className="flex-col items-center gap-1 ">
          <h4 className="font-extrabold">Pricing Plans</h4>
          <h6 className="text-txtSecondary">Choose a plan that suits you</h6>
        </div>
        <SegmentedControl
          onRoleChange={setSelectedRole}
          currentRoleStripe={isSubscribedStripe ? currentRoleStripe : undefined}
        />

        <Switcher
          firstLabel="Monthly"
          secondLabel="Yearly"
          onSwitchChange={(isChecked) => setIsMonthly(!isChecked)}
        />
      </div>
      <div className="flex gap-4 w-full mobile:flex-col-reverse mobile:items-center justify-center">
        {renderPlans()}
      </div>
    </main>
  );
};

export default SubscriptionPlans;
